import React, { Component } from 'react';
import * as _ from 'lodash';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Close as CloseIcon, CheckCircleOutlineOutlined } from '@material-ui/icons';
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import { withStyles } from '@material-ui/core/styles';
import { uuid } from 'utils/common';

class CostPriceModal extends Component {
  constructor(props) {
    super(props);
    const { aiItineraryData } = props;
    const { costPrice = 0 } = aiItineraryData;
    this.state = {
      costPrice,
    };
  }

  // Format price with commas
  formatPrice = (price) => {
    if (price === '-') return price;
    return `₹${price.toLocaleString('en-IN')}`;
  };

  updateComponentCostPrice = (componentId, value) => {    
    const { updateItineraryData, aiItineraryData } = this.props;  

    const itineraryParts = _.cloneDeep(aiItineraryData.itineraryParts).map((itineraryPart) => {      
      // eslint-disable-next-line no-param-reassign
      itineraryPart.itineraryPartId = itineraryPart.itineraryPartId || uuid();
      if (itineraryPart.itineraryPartId === componentId) {
        // console.log('updating cost price for component ', componentId, ' with value ', value);
        const numericValue = value.replace(/[^0-9]/g, '');
        return { ...itineraryPart, manualCostPrice: numericValue ? Number(numericValue) : 0 };
      }
      return itineraryPart;
    });

    // console.log('cost prices are ', itineraryParts.map((itineraryPart) => `${itineraryPart.itineraryPartId}: manualCostPrice: ${itineraryPart.manualCostPrice} manualCostPrice: ${itineraryPart.manualCostPrice} costPrice: ${itineraryPart.costPrice}`));
    
    let newCostPrice = 0
    if (itineraryParts.some((itineraryPart) => !itineraryPart.costPrice && !itineraryPart.manualCostPrice && !itineraryPart.isFree)) {
      newCostPrice = 0;
    } else {
      newCostPrice = _.sumBy(itineraryParts, (itineraryPart) => {
        const ipCostPrice = Number(itineraryPart.manualCostPrice) || itineraryPart.costPrice;
        // console.log(`itineraryPart ${itineraryPart.stayData?.stayName || itineraryPart.activityData?.experienceName}`, ipCostPrice, itineraryPart);
        return ipCostPrice;
      });

      newCostPrice += aiItineraryData.remittanceCostPrice || 0;
    }
    this.setState({ costPrice: newCostPrice });
    updateItineraryData({
      ...aiItineraryData,
      itineraryParts,      
    });
  };

  updateItineraryCostPrice = async () => {
    const {
      closePricingModal, aiItineraryData, updateCostPrice, openPricingModal,
    } = this.props;

    const spExists = aiItineraryData.sellPrice > 0;
    const finalAiItineraryData = {
      itineraryParts: [],
      costPrice: _.sumBy(aiItineraryData.itineraryParts, (itineraryPart) => itineraryPart.manualCostPrice || itineraryPart.manualCostPrice || itineraryPart.costPrice)
        + (aiItineraryData.remittanceCostPrice || 0),
      sellPrice: 0,
    };
    for (const itineraryPart of aiItineraryData.itineraryParts) {
      if (itineraryPart.manualCostPrice) {
        finalAiItineraryData.itineraryParts.push({
          itineraryPartId: itineraryPart.itineraryPartId,
          manualCostPrice: itineraryPart.manualCostPrice,
        });
      }
    }

    const { success } = await updateCostPrice(finalAiItineraryData);
    if (success) {
      if (spExists) {
        // a previous SP was set, which needs to be updated now
        openPricingModal('sell');
      } else {
        closePricingModal();
      }
    }
  };

  render() {
    const {
      isOpen,
      closePricingModal, aiItineraryData, classes,
      requestUsId, expert,
    } = this.props;

    const { costPrice } = this.state;

    if (!isOpen) return null;

    return (
      <div
        className={classes.overlay}
        onClick={closePricingModal}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Escape') closePricingModal();
        }}
      >
        <div
          className={classes.modal}
          onClick={(e) => e.stopPropagation()}
          role="button"
          tabIndex={0}
        >
          {/* Header */}
          <div className={classes.header}>
            <div className={classes.headerTitle}>
              <CheckCircleOutlineOutlined className={classes.headerIcon} />
              Update Cost Price
            </div>
            <button
              type="button"
              className={classes.closeButton}
              onClick={closePricingModal}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Content */}
          <div className={classes.content}>
            {/* Instructions */}
            <div className={classes.instructionsText}>
              Please enter the cost prices using available options.
            </div>

            {/* Pricing Components List */}
            <div className={classes.componentsContainer}>              
              {aiItineraryData.itineraryParts.map((itineraryPart) => (                
                (itineraryPart.costPrice > 0 || itineraryPart.isFree) ? <></> : (
                  <div key={itineraryPart.itineraryPartId} className={classes.componentRow}>
                    <div className={classes.componentInfo}>
                      <div className={classes.componentName}>{itineraryPart.stayData?.stayName || itineraryPart.activityData?.experienceName}</div>
                      <div className={classes.componentDetails}>
                        {(itineraryPart.stayData || itineraryPart.activityData)?.details?.map((detail) => (                          
                          (Array.isArray(detail) ? detail : [detail]).map((d, dIndex) => (
                            <div key={uuid()} className={classes.detailItem} style={{ paddingLeft: dIndex === 0 ? 0 : 10 }}>{dIndex === 0 ? '• ' : `- `} {d}</div>
                          ))
                        ))}
                      </div>
                    </div>

                    <div className={classes.componentActions}>
                      <div className={classes.inputContainer}>
                        <span className={classes.currencySymbol}>₹</span>
                        <input
                          type="text"
                          className={classes.input}
                          value={itineraryPart.manualCostPrice || ''}
                          onChange={(e) => this.updateComponentCostPrice(itineraryPart.itineraryPartId, e.target.value)}
                          placeholder="0"
                        />
                      </div>                      
                    </div>

                    <div>
                      <button
                        type="button"
                        className={clsx(classes.portalButton, itineraryPart.type === 'STAY' ? null : classes.hidden)}
                        onClick={() => {
                          const { openPricingModal } = this.props;
                          if (itineraryPart.type === 'STAY') {
                            if (itineraryPart.stayData?.isCruise) {
                              openPricingModal('cruisePortal', itineraryPart.itineraryPartId);
                            } else {
                              openPricingModal('hotelPortal', itineraryPart.itineraryPartId);
                            }
                          } else {
                            // Activity Portal - can be implemented later
                            // console.log('Activity Portal clicked for', itineraryPart.itineraryPartId);
                          }
                        }}
                      >
                        <LanguageOutlinedIcon className={classes.portalIcon} />
                        {/* eslint-disable-next-line no-nested-ternary */}
                        {itineraryPart.type === 'STAY'                    
                          // eslint-disable-next-line no-nested-ternary
                          ? (itineraryPart.stayData?.isCruise ? 'Cruise Portal' : 'Hotel Portal')
                          : 'NA'}
                      </button>
                      <div className={clsx(classes.buttonFooter, itineraryPart.type === 'STAY' ? null : classes.hidden)}>
                        Instant Pricing
                      </div>
                    </div>
                    <div>
                      <button
                        type="button"
                        className={clsx(classes.portalButton, itineraryPart.stayData?.isCruwise ? classes.hidden : null)}
                        onClick={() => {
                          if (_.isNil(aiItineraryData.quoteThreadId)) {
                            const { openPricingModal } = this.props;
                            openPricingModal('requestQuotation');
                          } else {                          
                            const query = `subject: Quote Request ${requestUsId}`;
                            const encodedQuery = encodeURIComponent(query);
                            const gmailUrl = `https://mail.google.com/mail/u/${expert.email}/#search/${encodedQuery}`;
                            window.open(gmailUrl, '_blank');
                          }
                        }}
                      >
                        <EmailOutlinedIcon className={classes.portalIcon} />
                        { _.isNil(aiItineraryData.quoteThreadId) ? 'Get Email Quote' : 'Reply on Email' }
                      </button>
                      <div className={classes.buttonFooter}>
                        Response in &lt;48 hours
                      </div>
                    </div>
                  </div>
                )
              ))}
            </div>

            {/* Final Cost Price */}
            
            <div className={classes.finalCostSection}>
              <div className={classes.finalCostLabel}>Final Cost Price</div>
              <div className={classes.finalCostValue}>{costPrice > 0 ? this.formatPrice(costPrice) : '-'}</div>
              <div className={classes.inclusionsText}>
                Inclusive of hotels, activities, transfers, visa & cruise
              </div>
            </div>

            {/* Update Button */}
            <button
              type="button"
              className={classes.updateButton}
              onClick={this.updateItineraryCostPrice}
            >
              Update Prices
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  hidden: {
    visibility: 'hidden !important',
  },
  modal: {
    width: 900,
    maxHeight: '90vh',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Sofia-pro, sans-serif',
  },
  header: {
    height: 56,
    borderBottom: '1px solid #DDDDDD',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 32px',
    flexShrink: 0,
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    fontSize: 20,
    fontWeight: 600,
    color: '#322F2C',
  },
  headerIcon: {
    color: theme.colors.primary,
    fontSize: 20,
    marginTop: 2,
    marginRight: 5,
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 8,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
  },
  content: {
    flex: 1,
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    overflowY: 'auto',
  },
  instructionsText: {
    fontSize: 14,
    color: '#E53935',
    lineHeight: 1.5,
    marginBottom: 20,
  },
  componentsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  componentRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '20px',
  },
  componentInfo: {
    flex: 2,
    marginRight: 10,
  },
  componentName: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.colors.lightText, 
  },
  componentDetails: {
    display: 'flex',
    flexDirection: 'column',    
  },
  detailItem: {
    fontSize: 12,
    color: theme.colors.lightText,    
  },
  componentActions: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  inputContainer: {
    position: 'relative',
    width: 130,
    marginRight: 10,
  },
  input: {
    width: '100%',
    height: 40,
    border: '1px solid #DDDDDD',
    borderRadius: 4,
    padding: '10px 16px 10px 40px',
    fontSize: 14,
    color: '#322F2C',
    fontFamily: 'Sofia-pro, sans-serif',
    '&:focus': {
      outline: 'none',
      borderColor: '#0090B5',
    },
    '&::placeholder': {
      color: '#DDDDDD',
    },
  },
  currencySymbol: {
    position: 'absolute',
    left: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 14,
    color: '#322F2C',
    pointerEvents: 'none',
  },
  portalButton: {
    width: 160,
    height: 36,
    marginRight: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '10px 10px',
    backgroundColor: '#FFFFFF',
    border: `1px solid ${theme.colors.primary}`,
    borderRadius: 20,
    color: theme.colors.primary,
    fontSize: 14,
    fontWeight: 'bold',
    cursor: 'pointer',
    fontFamily: 'Sofia-pro, sans-serif',
    position: 'relative',
    '&:hover': {
      backgroundColor: '#F0F9FB',
    },
  },
  portalIcon: {
    fontSize: 16,
    marginTop: 2,
    marginRight: 5,
  },
  portalBadge: {
    position: 'absolute',
    top: -6,
    right: -6,
    backgroundColor: '#43A047',
    color: '#FFFFFF',
    fontSize: 10,
    fontWeight: 600,
    padding: '2px 6px',
    borderRadius: 8,
  },
  finalCostSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 30,
  },
  finalCostLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.colors.textLight,
  },
  finalCostValue: {
    fontSize: 24,
    fontWeight: 700,
    color: theme.colors.textDark,
  },
  inclusionsText: {
    fontSize: 14,
    color: '#666666',
  },
  updateButton: {
    backgroundColor: '#0090B5',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 24,
    height: 36,
    padding: '0 40px',
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'Sofia-pro, sans-serif',
    alignSelf: 'flex-end',
    marginTop: 8,
    '&:hover': {
      backgroundColor: '#007A94',
    },
  },
  buttonFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    color: theme.colors.green,
    marginTop: 4,
    fontStyle: 'italic',
  },
});

CostPriceModal.propTypes = {
  aiItineraryData: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closePricingModal: PropTypes.func.isRequired,
  openPricingModal: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,  
  updateItineraryData: PropTypes.func.isRequired,
  updateCostPrice: PropTypes.func.isRequired,
  requestUsId: PropTypes.string,
  expert: PropTypes.object.isRequired,
};

export default withStyles(styles)(CostPriceModal);
